// export const url = "https://apibilling.opentech4u.co.in:3005"
// export const url = "https://apibilling.opentech4u.co.in:3010";
// export const url = "https://api.bill365.app";
// export const url = "http://192.168.1.32:3007"
// export const url = "http://98.130.88.168:3008";
// export const url = "https://webbackend.bill365.app"
export const url = "https://webbackend.synergicpos.in"

// export const url = "http://192.168.1.238:3001";
// export const url = "http://localhost:3005";
